@if (opportunityDatasource) {
    <app-server-side-grid
        [colDefs]="gridColumns()"
        [datasource]="opportunityDatasource"
        [appliedSort]="appliedSort"
        [noRows]="noResults()"
        [titleNoData]="'No Opportunities available.'"
        (cellValueChanged)="onCellValueChanged($event)"
        (cellSorting)="onSortChanged($event)"
        [storageKey]="storageKey()"
    >
    </app-server-side-grid>
}
